import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactsForLead as GetContactsForLeadQuery,
    GetContactsForLeadVariables as GetContactsForLeadVariables,
    GetContactsForLead_lead_contacts as Contacts,
} from 'nutshell-graphql-types';

import GET_CONTACTS_FOR_LEAD from '../queries/get-contacts-for-lead.graphql';

export const useGetContactsForLead = (
    leadId: string
): {
    contacts: Contacts | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetContactsForLeadQuery,
        GetContactsForLeadVariables
    >(GET_CONTACTS_FOR_LEAD, {
        variables: {
            leadId,
        },
    });

    return {
        contacts: data && data.lead && data.lead.contacts,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
